import { render, staticRenderFns } from "./MemberIndex.vue?vue&type=template&id=71efb0be&scoped=true&"
import script from "./MemberIndex.vue?vue&type=script&lang=js&"
export * from "./MemberIndex.vue?vue&type=script&lang=js&"
import style0 from "./MemberIndex.vue?vue&type=style&index=0&id=71efb0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71efb0be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71efb0be')) {
      api.createRecord('71efb0be', component.options)
    } else {
      api.reload('71efb0be', component.options)
    }
    module.hot.accept("./MemberIndex.vue?vue&type=template&id=71efb0be&scoped=true&", function () {
      api.rerender('71efb0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket/MemberIndex.vue"
export default component.exports